module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAYAAACN1PRVAAAACXBIWXMAAAsSAAALEgHS3X78AAABGklEQVRIx+2W4W2DMBSEP1f5H0bwCGxQRskIbFC6QUdgBFboBoyQTtBkguuPPFIHxcFINkqlPukkzLN9PnMP20liq3hhw3h+MgeVg2orZR9Au3qRaw1iio7W9IJTSWUtsDe0WZU5aLjAG16D9BkYTekRGHRp3w9JD4FUI50WO0ojUrUwl3IQLhJJSjeIGeP7TuqcapQcRb1PdeQasjp4/jJMquuUCXbWuYvke/3WVGMEnaAPxrW2kNHeeeAQdSNSF/mqTWASHzFPFeaQmshch3DQ8IgsFRGy/sb6tsKRtbMn1N/0ODeIL3G0XE+IQFkJVROG6zYi9QWJJnRO0tz6b5l38T3613eQ9QYkcDdFPYvPUncQ93+V+3NkP25xXUjU7ZMQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/level_icon1.png
// module id = N2Z/
// module chunks = 1